import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import contentPages from '../generated/content-pages.json';
import './ArticlesList.css';

function ArticlesList() {
  const { t } = useTranslation();

  const articles = useMemo(() => {
    const entries = Object.values(contentPages.articles || {});
    return entries.sort((a, b) => {
      const dateA = a.modified || '';
      const dateB = b.modified || '';
      if (dateA !== dateB) return dateB.localeCompare(dateA);
      return a.title.localeCompare(b.title, 'fr');
    });
  }, []);

  const pageMeta = {
    title: t('articlesIndex.title'),
    path: '/articles/',
  };

  return (
    <>
      <SEO
        title={t('articlesIndex.seoTitle')}
        description={t('articlesIndex.seoDescription')}
        canonical="/articles/"
      />
      <StructuredData page="articles" contentPage={pageMeta} />
      <main className="articles-list-page" id="main-content">
        <div className="articles-list-container">
          <header className="articles-list-header">
            <h1>{t('articlesIndex.title')}</h1>
            <p className="articles-list-subtitle">{t('articlesIndex.subtitle')}</p>
          </header>

          <ul className="articles-grid">
            {articles.map((article) => (
              <li key={article.slug}>
                <article className="article-card">
                  <h2 className="article-card-title">
                    <Link to={article.path}>{article.title}</Link>
                  </h2>
                  <p className="article-card-description">{article.description}</p>
                  <Link to={article.path} className="article-card-link">
                    {t('articlesIndex.readMore')}
                    <span aria-hidden="true"> →</span>
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </>
  );
}

export default ArticlesList;
